import t from "react";
const o = t.createContext({});
export {
  o as AnalyticsContext
};
